import { OutOfBandTransactionStatus } from "@modules/finances/boxPaymentAtCounter/entities/outOfBandTransactionType"
import {
  TransactionBoxDetailsDtoSchema,
  TransactionDiscountDtoSchema,
  TransactionLineDtoSchema,
  TransactionProductDtoSchema,
  TransactionUserDetailsDtoSchema,
  TransactionUserDtoSchema,
} from "@modules/finances/gateway/transactionDto"
import { z } from "zod"

export const OutOfBandTransactionDtoSchema = z
  .object({
    invoiceId: z.string(),
    date: z.iso.datetime(),
    user: TransactionUserDtoSchema,
    amount: z.number(),
    currency: z.string(),
    status: z.enum(OutOfBandTransactionStatus).nullable(),
    product: TransactionProductDtoSchema,
  })
  .meta({ id: "OutOfBandTransactionDtoSchema" })

export type OutOfBandTransactionDto = z.infer<typeof OutOfBandTransactionDtoSchema>

export const OutOfBandTransactionDetailDtoSchema = z
  .object({
    invoiceId: z.string(),
    date: z.iso.datetime(),
    user: TransactionUserDetailsDtoSchema.nullable(),
    box: TransactionBoxDetailsDtoSchema.nullable(),
    amount: z.number(),
    netAmount: z.number(),
    totalTaxAmount: z.number(),
    fee: z.number(),
    currency: z.string(),
    status: z.enum(OutOfBandTransactionStatus).nullable(),
    invoiceNumber: z.string(),
    invoicePdfUrl: z.string().nullable(),
    lines: z.array(TransactionLineDtoSchema).nullable(),
    discount: TransactionDiscountDtoSchema.nullable(),
  })
  .meta({ id: "OutOfBandTransactionDetailDtoSchema" })

export type OutOfBandTransactionDetailDto = z.infer<typeof OutOfBandTransactionDetailDtoSchema>
